<template>
    <div class="detail" v-if="projectDict && data">
        <div class="main-imgs">
            <div class="box">
                <el-image :src="data.pictureUrl[0]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image :src="data.pictureUrl[1]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[2]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image  :src="data.pictureUrl[3]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[4]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
        </div>
        <div class="contentfile"  v-if="fileList.length>0">
             <div v-for="(item,index) in fileList" :key="index" @click="tolink(item)" style="cursor:pointer;">
                 {{ item }}
             </div>   
        </div>  
        <div class="content">
            <span>项目类型：{{ data.projectTypeName }}</span>
            <span>项目类别：{{ data.projectCategoryName }}</span>
            <span>供求类型：{{ data.supplyTypeName }}</span>
            <span>联系人：{{ data.contact }}</span>
            <span>联系方式：{{ data.phone }}</span>
            <a-button type="primary"  @click="getVideos">查看视频</a-button><br>
            <span>描述：{{ data.descContent }}</span>
        </div>
      
         <videoList ref="videoList"></videoList>
    </div>    
</template>
<script>
export default {
    data(){
        return{
            data:'',
            projectDict:'',
            enviromentName:[],
            query:{
                biddingId:'',
                applyUrl:'',
            },
            imageUrl:'',
            visible:false,
            loading:false,
            currentItem:'',
            fileList:[],
            bankInfo:''
        }  
    },
    created(){
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    this.getBaseInfo(this.$route.query.id)
                }else{
                     this.$message.info(res.msg)
                }
        })
    },
    mounted(){
        this.$parent.current = '6';
    },
    methods:{
        getBaseInfo(id){
            this.$https.get(`/portal/entrust/${id}`).then(res=>{
                if(res.code == 200){
                    res.data.pictureUrl = res.data.pictureUrl.split(',');
                    // res.data.enviroment = res.data.enviroment.split(',');
                    // res.data.enviroment.forEach(item=>{
                    //     this.projectDict.bg_enviroment.forEach(ele=>{
                    //         if(item == ele.dict_value){
                    //             this.enviromentName.push(ele.dict_label)
                    //         }
                    //     })
                    // })
                    this.data = res.data;
                    this.fileList = this.data.fileUrl?this.data.fileUrl.split(','):[];
                }
            })
        },
        getFile(info){
           this.imageUrl = info.file.response.data.url;

        },
        getVideos(){
            let videoList = [];
                videoList = this.data.videoUrl?this.data.videoUrl.split(','):[];
                console.log(this.data)
            if(videoList.length == 0){
                this.$message.info('没有发现视频喔')
            }else{
                this.$refs.videoList.showDialog(videoList)
            }
        },
        tolink(item){
           window.open(item)
        }
    }
}
</script>

<style lang="less" scoped>
.detail{
      width: 1300px;
      margin: 0 auto;
      .main-imgs{
          display: flex;
          .box{
                border:5px solid #fff;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                &:nth-of-type(1){
                    width: 770px;
                    height: 440px;
                    margin-right:5px;
                    background: coral;
                    .el-image{
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(2){
                    width: 260px;
                    height: 440px;
                    margin-right:5px;
                    background:darkgray;
                    flex-direction: column;
                        .el-image{
                            height: 215px;
                            width: 260px;
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(3){
                    width: 260px;
                    height: 440px;
                    background:darkorange;
                    flex-direction: column;
                       .el-image{
                            height: 215px;
                            width: 260px;
                               &:hover{
                                    transform:scale(1.2,1.2);
                                    transition:All 0.4s ease-in-out;
                                    -webkit-transition:All 0.4s ease-in-out;
                                    -moz-transition:All 0.4s ease-in-out;
                                    -o-transition:All 0.4s ease-in-out;
                                }
                        }
                }
          }
      }
      .content{
         background: white;
         line-height: 40px;
         padding: 20px 10px;
         margin-top:10px;
         span{
             margin-right:70px;
         }
         .ant-btn{
             float: right;
             margin-top:9px;
             margin-left:20px;
         }
      }
      .contentfile{
         background: white;
         line-height: 20px;
         padding: 10px 10px;
         margin-top:10px;
      }
      .projectDetail{
          display: flex;
          flex-wrap:wrap;
          background: white;
          margin:20px 0;
          padding: 10px;
          div{
              width: 25%;
              line-height: 30px;
          }
      }
}
</style>